export default {"src":"/_next/static/media/logo-white.1d0ca221.svg","height":146,"width":384,"blurWidth":0,"blurHeight":0};